/**
 * Date-extensions locale Basque [eu]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('eu', {
    monthNames: ['Urtarrila','Otsaila','Martxoa','Apirila','Maiatza','Ekaina','Uztaila','Abuztua','Iraila','Urria','Azaroa','Abendua'],
    monthShortNames: ['Urt.','Ots.','Mar.','Api.','Mai.','Eka.','Uzt.','Abu.','Ira.','Urr.','Aza.','Abe.'],
    dayNames: ['Igandea','Astelehena','Asteartea','Asteazkena','Osteguna','Ostirala','Larunbata'],
    dayShortNames: ['Ig.','Al.','Ar.','Az.','Og.','Ol.','Lr.']
});
